<cfe-hero-banner></cfe-hero-banner>

<section class="intro">
	<div class="container-fluid">
		<h1 class="d-md-none mb-5 text-center">Connect Case Center</h1>
		<div class="row equal">
			<div class="col-md-4 mb-5 mb-md-0 text-center text-md-left">
				<h3>{{ 'start.title.aboutConnectCaseCenter' | translate }}</h3>
				<p class="mb-auto">{{ 'start.text.aboutConnectCaseCenter' | translate }}</p>
				<a [href]="learnMoreUrl" target="_blank" class="learn-more mt-4 btn btn-icon btn-primary"
					>{{ 'start.button.learnMore' | translate }}<i class="cfe cfe-forward-arrow"></i
				></a>
			</div>
			<div class="col-md-4 mb-5 mb-md-0 text-center text-md-left">
				<h3>{{ 'start.title.login' | translate }}</h3>
				<p class="mb-auto">{{ 'start.text.myConnectCaseCenter' | translate }}</p>
				<cfe-button
					class="mt-4"
					[buttonStyle]="'btn-primary'"
					[iconName]="'forward-arrow'"
					[label]="'start.button.loginNow' | translate"
					(click)="goToLogin()"
				></cfe-button>
			</div>
			<div class="col-md-4 mb-5 mb-md-0 text-center text-md-left">
				<h3>{{ 'start.title.register' | translate }}</h3>
				<p class="mb-auto">{{ 'start.text.registerNow' | translate }}</p>
				<cfe-button
					class="mt-4"
					[buttonStyle]="'btn-primary'"
					[iconName]="'forward-arrow'"
					[label]="'start.button.registerNow' | translate"
					(click)="goToRegister()"
				></cfe-button>
			</div>
		</div>
		<div *ngIf="showCountryDeactivationNotice" class="row equal">
			<div class="col-md-4"></div>
			<div class="col-md-4"></div>
			<div class="col-md-4 mb-5 mb-md-0 text-center text-md-left">
				<div class="mt-4 info" [innerHtml]="'start.text.countryDeactivation' | translate | keepHtml"></div>
			</div>
		</div>
	</div>
</section>
